module.exports = __webpack_public_path__ + "static/media/img02.4cf552aa.JPG";